module.exports = __webpack_public_path__ + "img/find-my-icon.be25c6b2.png";